/* eslint-disable no-prototype-builtins */
import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import { useQuery } from '@apollo/client';

import Loader from '@components/shared/Loader/Loader';
import { SEARCH_DISCOVER_PAGES } from '@components/pages/ExploreFeed/graphql/discoverFeed.graphql';
import ShowAt from '@components/shared/conditional/ShowAt';
import topics from '@constants/topicPageLinks';
import { useTheme } from '@components/theme';
import classNames from 'classnames';
import styles from './styles.module.scss';

function ImageCard({ topic }) {
  return (
    <Link href={`/exp/${topic.slug}`}>
      <a href={`/exp/${topic.slug}`}>
        <div
          className={styles.ImageCard}
          style={{
            backgroundImage: `linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(0, 0, 0, 0.41) 100%), url(${topic.imageUrl})`,
          }}
        >
          <div className={styles.ImageText}>
            {topic.shortName}
          </div>
        </div>
      </a>
    </Link>
  );
}

function getRoomTopics() {
  return topics.filter((topic) => topic.hasOwnProperty('roomNav'))
    .sort((a, b) => a.roomNav - b.roomNav)
    .map((topic) => (<ImageCard topic={topic} key={`room-topic-image-card-${topic.slug}`} />));
}

function getPopularSearches(popularTopics) {
  return popularTopics.map((topic) => (
    <div
      className={styles.Pill}
      key={`popular-search-item-${topic.slug}`}
    >
      <Link href={`/exp/${topic.slug}`}>
        <a href={`/exp/${topic.slug}`} className={styles.PillLink}>
          <div className={styles.PillText}>
            {topic.shortName}
          </div>
        </a>
      </Link>
    </div>
  ));
}

function getStyleTopics() {
  return topics.filter((topic) => topic.hasOwnProperty('styleNav'))
    .sort((a, b) => a.styleNav - b.styleNav)
    .map((topic) => (<ImageCard topic={topic} key={`style-topic-image-card-${topic.slug}`} />));
}

const SearchResults = ({ queryText }) => {
  const { loading, error, data } = useQuery(SEARCH_DISCOVER_PAGES, {
    variables: {
      query: queryText
    },
  });

  if (loading || error) {
    return <Loader />;
  }

  const results = data.searchDiscoverPages;

  return (
    <div className={styles.SearchResults}>
      {results.map((topic) => (
        <Link href={`/exp/${topic.slug}`} key={`discover-page_${topic.slug}`}>
          <a href={`/exp/${topic.slug}`} className={styles.SearchResultLink}>
            <div>
              {topic.name}
            </div>
          </a>
        </Link>
      ))}
    </div>
  );
};

const NavSearch = ({ queryText }) => {
  const [popularSearches, setPopularSearches] = useState([]);
  const theme = useTheme();
  useEffect(() => {
    const popular = topics.filter((topic) => !topic.hasOwnProperty('styleNav') && !topic.hasOwnProperty('roomNav'))
      .map((topic) => [Math.random(), topic])
      .sort().map((n) => n[1])
      .slice(0, 8);

    if (popularSearches.length === 0) {
      setPopularSearches(popular);
    }
  }, []);

  if (queryText && queryText.length >= 3) {
    return <SearchResults queryText={queryText} />;
  }
  return (
    <div className={classNames(styles.Content, theme.styles.Body)}>
      <div className={styles.Ideas}>
        <div className={styles.Heading}>
          Designs by room
        </div>
        <div className={styles.RoomImageContainer}>
          {getRoomTopics()}
        </div>
      </div>

      <div className={styles.Popular}>
        <div className={styles.Heading}>
          Popular searches
        </div>
        <div className={styles.PopularContainer}>
          {getPopularSearches(popularSearches)}
        </div>
      </div>

      <ShowAt breakpoint="desktop">
        <div className={styles.ByStyle}>
          <div className={styles.Heading}>
            Designs by style
          </div>
          <div className={styles.RoomImageContainer}>
            {getStyleTopics()}
          </div>
        </div>
      </ShowAt>
    </div>
  );
};

export default NavSearch;
